import {Action} from '@ngrx/store';

export const DELETE_SHARED_LINK_ACTION = 'DELETE_SHARED_LINK_ACTION';

export class DeleteSharedLinkAction implements Action {
  readonly type = DELETE_SHARED_LINK_ACTION

  constructor(public payload: any) {
  }
}
